module.exports = __webpack_public_path__ + "assets/9539cf76af6ddca8c529de2d078e8349.png";